import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import {ifAuthenticated} from './auth.guard';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
	// {
	// 	path: '/',
	// 	name: 'Home',
	// 	component: () => import('../views/Maintenance/Maintenance.vue'),
	// 	children: [
	// 		{
	// 			path: '/app',
	// 			name: 'UserQueuesPanel',
	// 			component: () => import('../views/Maintenance/Maintenance.vue')
	// 		}
	// 	]
	// }
	{
	    path: '/login',
	    name: 'Login',
	    component: () => import('../views/Login/Login.vue')
	},
	{
	    path: '/login-faq',
	    name: 'LoginFaq',
	    component: () => import('../views/Login/LoginFaq.vue')
	},
	{
	    path: '/',
	    name: 'Home',
	    component: () => import('../views/Home/Home.vue'),
	    beforeEnter: (to, from, next) => {
	        ifAuthenticated(to, from, next);
	    },
	    children: [
	        {
	            path: '/app',
	            name: 'UserQueuesPanel',
	            component: () => import('../views/UserQueuesPanel/UserQueuesPanel.vue')
	        },

	        {
	            path: '/admin',
	            name: 'Administration',
	            component: () => import('../views/Administration/Administration.vue'),
	            children: [
	                //   {
	                //     path: '/admin/add-new-queue',
	                //     name: 'AddNewQueue',
	                //     component: () => import('../components/AddNewQueue/AddNewQueue.vue')
	                //   },
	                {
	                    path: '/admin/queues-management',
	                    name: 'QueuesManagement',
	                    component: () => import('../views/Administration/QueuesManagement/QueuesManagement.vue')
	                },
	                //   {
	                //     path: '/admin/users-management',
	                //     name: 'UsersManagement',
	                //     component: () => import('../components/UsersManagement/UsersManagement.vue')
	                //   },
	                {
	                    path: '/admin/queues-report',
	                    name: 'QueuesReport',
	                    component: () => import('../views/Administration/QueuesReport/QueuesReport.vue')
	                }
	            ]
	        },
	        {
	            path: '/post-auth',
	            name: 'PostAuth',
	            component: () => import('../views/PostAuth/PostAuth.vue')
	        },
	        {
	            path: '/403',
	            name: 'E403',
	            component: () => import('../views/Errors/403.vue')
	        },
	        {
	            path: '*',
	            name: 'E404',
	            component: () => import('../views/Errors/404.vue'),
	            beforeEnter: (to, from, next) => {
	                if (to.path === '/' && from.path === '/') {
	                    // TODO: W ZALEZNOSCI OD ROLI ALBO DO APP ALBO DO ADMIN
	                    next('/app');
	                }

	                next();
	            }
	        }
	    ]
	}
];

const router = new VueRouter({
	                             mode: 'history',
	                             base: process.env.BASE_URL,
	                             routes
                             });

// router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
//
//     // TODO disable if maintenance mode is off
//     if (to.path !== '/') {
//         next({name: 'Home'})
//     }
//
//     next();
// });


export default router;
